<template lang="pug">
div
    v-expansion-panels.pa-2(multiple v-model="panel")
      v-expansion-panel
        v-expansion-panel-header.text-h6 Summary
        v-expansion-panel-content {{ tripSummary }} 
          v-card-text 
            p <strong>For more route information, <a href="https://www.powertrip.earth/" target="_blank" class="plainLink" rel="noopener noreferrer">download the Power Trip app</a></strong>
            p The results provided below are based on Power Trip's best possible estimate and take into account factors like terrain, elevation and the physics of your EV. Other factors can affect your driving range, so this estimate may be different to your actual range.
            p By using this tool, you agree to these 
                a(href="https://powertrip.earth/terms-and-conditions") terms and conditions
      v-expansion-panel
        v-expansion-panel-header.text-h6 Range Radar
        v-expansion-panel-content Choose a place on the map to see all charging stations within your chosen EV's driving range
          AddressFinder(:model="radarAddress" :clear="true" label="Chargers in Range of" @change="updateRadar")
      v-expansion-panel
        v-expansion-panel-header.text-h6 Charging Stations
        v-expansion-panel-content Power Trip shows only the charging stations you need to stop at along your route.
          v-checkbox(v-model="allChargers" label="See all charging stations instead" @change="toggleAllChargers")
    v-row(v-if="mobile")
      v-col(cols=12)
        v-btn.primary(block @click="showPlanner") Recommend an EV
    v-card(class="ma-2 pa-2" class="secondary" dark)
      v-card-title Start at {{ getName(trip.fromAddress.Address,"destination") }} with {{ startCharge }}% charge

    div( v-for="(s,index) in stops.charging_steps" :key="s.id")

        v-card(class="ma-2 pa-2" :dark="!$dealer.default_settings.theme.dark" :light="$dealer.default_settings.theme.dark == 1")
          v-card-title(v-if="index == 0") Drive to {{ s.name }}
          v-card-title(v-if="index > 0") Drive {{ stops.charging_steps[index - 1].name }} - {{ s.name }}
          v-card-text {{ (getStepData(index).dist / 1000).toFixed(2) }}kms - {{ niceDuration(getStepData(index).time) }} - {{ roundedkWh(s.used_energy) }} ({{ batteryPercent(s.used_energy)}})
        v-card(class="ma-2 pa-2")
          v-card-title {{ s.name }}
          v-card-text
            v-row(dense class="mb-2" v-if="getCharger(s)")
              v-img(v-for="c of getCharger(s).Plugs" :key="c.ID" :src="plugImage(c.Name)" max-height="40" max-width="40" class="ma-2")
            table
              tr
                td Arrive with:
                td {{ roundPercent(s.arrival_charge) }}
              tr(v-if="s.arrival_charge != s.departing_charge")
                td
                  strong Charge to:
                td
                  strong {{ roundPercent(s.departing_charge) }}
              tr(v-if="s.charging_duration")
                td Charge time:
                td about {{ niceDuration(s.charging_duration) }}
              tr(v-if="s.charging_cost")
                td Charging cost:
                td about {{ chargeCost(s.charging_cost)}}
    
    v-card(class="ma-2 pa-2" class="secondary" dark)
      v-card-title Arrive at {{ getName(trip.toAddress.Address,"destination") }} with {{ endCharge }} charge
 
</template>

<script>
import AddressFinder from "./AddressFinder.vue";
import ActionBar from "../components/ActionBar.vue";
export default {
  components: { AddressFinder, ActionBar },
  props: [
    "tripSummary",
    "stops",
    "trip",
    "driver",
    "summary",
    "car",
    "chargers",
    "radarAddress",
  ],
  data() {
    return {
      panel: [0, 1, 2, 3, 4],
      allChargers: false,
    };
  },
  computed: {
    startCharge() {
      return this.driver.battery;
    },
    endCharge() {
      return this.roundPercent(this.summary.arrival_charge);
    },
  },
  methods: {
    showPlanner() {
      this.$router.push("/recommender/2");
    },
    updateRadar() {
      this.$emit("addressUpdated");
    },
    toggleAllChargers() {
      this.$emit("toggleAllChargers", this.allChargers);
    },
    getCharger(s) {
      return this.chargers.find((e) => e.ID == s.id);
    },
    plugImage(name) {
      let convertedName = name.replace(/\s/g, "_").toLowerCase() + ".png";
      return "https://powersell.appstack.me/plug_images/" + convertedName;
    },
    chargeCost(c) {
      return "$" + this.formatPrice(c);
    },
    roundPercent(value) {
      return Math.floor(value * 100) + "%";
    },
    roundedkWh(value) {
      return value.toFixed(2) + "kWh";
    },
    batteryPercent(value) {
      console.log(this.stops);
      let total = this.car.BatterySize * (this.driver.soh / 100);
      return Math.floor((value / total) * 100) + "%";
    },
    getStepData(index) {
      let data = {};
      if (this.stops) {
        if (index == 0) {
          data.dist = this.stops.charging_steps[0].cumulative_distance;
          data.time = this.stops.charging_steps[0].cumulative_time;
        } else {
          data.dist =
            this.stops.charging_steps[index].cumulative_distance -
            this.stops.charging_steps[index - 1].cumulative_distance;
          data.time =
            this.stops.charging_steps[index].cumulative_time -
            this.stops.charging_steps[index - 1].cumulative_time;
        }
      }
      return data;
    },
    getName(address, fallback) {
      if (address.properties.name) {
        return address.properties.name;
      }
      if (address.properties.city) {
        return address.properties.city;
      }
      if (address.Address) {
        return address.Address;
      }
      return fallback;
    },
  },
};
</script>

<style scoped>
.plainLink {
  text-decoration: none !important;
}
</style>
